module.exports = __webpack_public_path__ + "img/lab.17ff4364.svg";